import { defectTypeApi } from '@/apis/defect.type.api';
import { moduleDefectApi } from '@/apis/module.defect.api';
import { log } from '@/utils/logger';

/**
 * 결함 유형·목록 데이터 소스 단일 진입점.
 * - 상위 유형: defectTypeApi (정적 JSON 또는 서버, env 플래그)
 * - 하위 유형·이미지별 결함 목록: moduleDefectApi
 */

export async function fetchParentDefectTypes() {
  const data = await defectTypeApi.getParentDefectTypes();
  const types = data?._embedded?.defectTypes;
  return Array.isArray(types) ? types : [];
}

export async function fetchChildDefectTypes(parentId) {
  if (parentId == null || parentId === '') {
    return [];
  }
  const childTypes = await moduleDefectApi.getChildrenDefectTypes(parentId);
  return Array.isArray(childTypes) ? childTypes : [];
}

export async function fetchDefectsByThermalImageId(thermalImageId, aiInclude) {
  const defectResponse = await moduleDefectApi.getDefectsByThermalImageId(
    thermalImageId,
    aiInclude
  );
  const defects = defectResponse?.content || [];

  log.info(
    'DEFECT-REPO',
    `fetchDefectsByThermalImageId thermalImageId=${thermalImageId} aiInclude=${aiInclude} (n=${defects.length})`,
    defects
  );

  return defects;
}
